import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ApiResponse,
  InstitutionResponse,
  UpdateInstitutionRequest,
  UpdateInstitutionStatusRequest
} from '../models/models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InstitutionService {
  private readonly apiUrl = `${environment.apiUrl}/institutions`;

  constructor(private http: HttpClient) {}

  getAllInstitutions(): Observable<ApiResponse<InstitutionResponse[]>> {
    return this.http.get<ApiResponse<InstitutionResponse[]>>(this.apiUrl);
  }

  getInstitutionByUid(uid: string): Observable<ApiResponse<InstitutionResponse>> {
    return this.http.get<ApiResponse<InstitutionResponse>>(`${this.apiUrl}/${uid}`);
  }

  updateInstitution(uid: string, request: UpdateInstitutionRequest): Observable<ApiResponse<InstitutionResponse>> {
    return this.http.put<ApiResponse<InstitutionResponse>>(`${this.apiUrl}/${uid}`, request);
  }

  updateInstitutionStatus(uid: string, request: UpdateInstitutionStatusRequest): Observable<ApiResponse<InstitutionResponse>> {
    return this.http.patch<ApiResponse<InstitutionResponse>>(`${this.apiUrl}/${uid}/status`, request);
  }

  toggleStatus(uid: string, isActive: boolean): Observable<ApiResponse<InstitutionResponse>> {
    return this.updateInstitutionStatus(uid, { isActive });
  }
}
